export default {"src":"/_next/static/media/logo.003d9d4d.svg","height":83,"width":81,"blurWidth":0,"blurHeight":0};